import { baseFunc } from './server-base';
export const ScannerApi = baseFunc('scannedlog');
export const LoginApi = baseFunc('inspectors/login');
export const InspectorQR = baseFunc('inspectionqr');
export const ReasonsAPI = baseFunc('reasons');
export const InspectorDetailsAPI = baseFunc('inspectionqr');
